// @flow
import React from 'react'
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'
import I18n from 'i18n-react/dist/i18n-react'

// types
type ValidationMessageModalProps = {
  isOpen: boolean,
  onToggle: () => {},
  onBack: () => {},
  onShowCallback: () => {},
}

const ValidationMessageModal = (props: ValidationMessageModalProps) => {
  return (
    <Modal contentClassName='border-0' isOpen={props.isOpen} toggle={props.onToggle}>
      <ModalBody className='border-0 m-0 p-0'>
        <div className='alert alert-error mw-100 m-0' role='alert'>
          <div className='alert-header bg-primary'>
            <h5 className='alert-title' onClick={props.onToggle}>
              {I18n.translate('validationErrors.validationMessage.title')}
            </h5>
            <a className='close btn btn-link' onClick={props.onToggle}>
              <i className='pfp pfp-close'/>
            </a>
          </div>
        </div>
        <div className='alert-body py-4 px-3'>
          <p>{I18n.translate('validationErrors.validationMessage.message')}</p>
          <div className='row'>
            <div className='col-6 text-center'>
              <a className='btn btn-secondary text-white px-3' onClick={props.onShowCallback}>
                {I18n.translate('validationErrors.validationMessage.callback')}
              </a>
            </div>
            <div className='col-6 text-center'>
              <a className='btn btn-secondary text-white px-3' onClick={props.onBack}>
                {I18n.translate('validationErrors.validationMessage.back')}
              </a>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ValidationMessageModal
